var exports = {
  "Iq": "UserAreaAccountSwitchMenu.module__switchMenu___UzhLSm" + " " + __webpack_require__(890070)["HG"],
  "ed": "UserAreaAccountSwitchMenu.module__switchMenuList___UzhLSm",
  "XT": "UserAreaAccountSwitchMenu.module__instanceGroup___UzhLSm",
  "Ur": "UserAreaAccountSwitchMenu.module__instanceHeading___UzhLSm",
  "Xf": "UserAreaAccountSwitchMenu.module__instanceHeadingMark___UzhLSm",
  "Ao": "UserAreaAccountSwitchMenu.module__instanceHeadingLabel___UzhLSm",
  "QM": "UserAreaAccountSwitchMenu.module__instanceAccounts___UzhLSm",
  "RC": "UserAreaAccountSwitchMenu.module__switchMenuFooter___UzhLSm",
  "IK": "UserAreaAccountSwitchMenu.module__manageAccountsButton___UzhLSm" + " " + __webpack_require__(890070)["AS"],
  "E1": "UserAreaAccountSwitchMenu.module__accountMenuItem___UzhLSm" + " " + __webpack_require__(890070)["AS"],
  "gK": "UserAreaAccountSwitchMenu.module__accountMenuAvatar___UzhLSm",
  "FH": "UserAreaAccountSwitchMenu.module__accountMenuInfo___UzhLSm",
  "fv": "UserAreaAccountSwitchMenu.module__accountMenuTag___UzhLSm",
  "Bt": "UserAreaAccountSwitchMenu.module__accountMenuNameText___UzhLSm",
  "x": "UserAreaAccountSwitchMenu.module__accountMenuDiscriminator___UzhLSm",
  "eb": "UserAreaAccountSwitchMenu.module__accountMenuMeta___UzhLSm",
  "Xc": "UserAreaAccountSwitchMenu.module__accountMenuMetaExpired___UzhLSm",
  "Bw": "UserAreaAccountSwitchMenu.module__accountMenuCheck___UzhLSm",
};

module.exports = exports;
